import { render, staticRenderFns } from "./part-calendar-single-to-plural.vue?vue&type=template&id=511a0490&lang=pug"
import script from "./part-calendar-single-to-plural.vue?vue&type=script&lang=js"
export * from "./part-calendar-single-to-plural.vue?vue&type=script&lang=js"
import style0 from "./part-calendar-single-to-plural.vue?vue&type=style&index=0&id=511a0490&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports